import { setAuthConfig, IAuthConfig } from 'auth/AuthConfig';
import { setServerRoot } from 'redux/actions/dataActions/dataActionConstants';

export async function SetupApp(callBack: () => void)
{
	await SetupAuthConfig();
	await SetupBackendConfig();

	callBack();
}

interface IEnvironment
{
	name: string,
	hostnames: string [],
	authClientId: string,
	authDomain: string,
    authAudience: string,
    apiServerRoot: string,
    appInsightsKey: string,
}

const environments: IEnvironment [] = [
    {
        name: 'Development',
        hostnames: ['localhost', 'aptec-development.agamemnon-cricket.synology.me', 'https://myaptec-development.aptec.be/'],
        authClientId: 'cTzKXBBWlLxTPFwBASDQAXyMJCkWhKBx',
        authDomain: 'aptec-staging.eu.auth0.com',
        authAudience: 'CustomerApi-Development',
        apiServerRoot: 'https://myaptec-development.aptec.be/',
        appInsightsKey: '344f78da-604b-4a48-9ccd-7d27bb2bcfbd',
    },
    {
        name: 'Staging',
        hostnames: ['myaptec-staging.aptec.be'],
        authClientId: 'ZLrgyN7OwCoXnKvum4X4Kk5d5fGApAyZ',
        authDomain: 'aptec-staging.eu.auth0.com',
        authAudience: 'CustomerApi-Staging',
        apiServerRoot: 'https://myaptec-staging.aptec.be',
        appInsightsKey: '344f78da-604b-4a48-9ccd-7d27bb2bcfbd',
    },
    {
        name: 'Production',
        hostnames: ['myaptec.aptec.be'],
        authClientId: 'wgbeETT9EWXKqdrd3IwI2utJL4rcvgfK',
        authDomain: 'auth.aptec.be',
        authAudience: 'CustomerApi-Production',
        apiServerRoot: 'https://myaptec.aptec.be',
        appInsightsKey: '2278d59b-3e7a-47c4-b491-8a34bf36ae49',
    },
]

export const returnAppInsightsKey = () => {
	const { hostname } = new URL(window.location.href)
	const currentEnv = environments.find(x => x.hostnames.includes(hostname)) || environments[0]
    return currentEnv.appInsightsKey
}

async function SetupAuthConfig()
{

	const { origin, hostname } = new URL(window.location.href)
	
	const currentEnv: IEnvironment = environments.find(x => x.hostnames.includes(hostname)) || environments[0]

	const appRoot = process.env.REACT_APP_ROOT_PATH

	const config: IAuthConfig = {
		domain: currentEnv.authDomain,
        client_id: currentEnv.authClientId,
        audience: currentEnv.authAudience,
		redirect_uri: origin+appRoot,
        logout_redirect_uri: origin+appRoot,
	}

	setAuthConfig(config);
}

async function SetupBackendConfig()
{
    const { hostname } = new URL(window.location.href)

    const currentEnv: IEnvironment = environments.find(x => x.hostnames.includes(hostname)) || environments[0]

    // const serverRoot = process.env.REACT_APP_SERVER
    const serverRoot = currentEnv.apiServerRoot
    console.log({serverRoot})
	setServerRoot(serverRoot);
}